import { useEffect, useState } from 'react';

import { usePerpetualOptions } from './use-perpetual-options';
import { useVolatilityOptions } from './use-volatility-options';
import { RequestTypeEnum, PerpTokenData } from '../../../../../../providers/timeseries-provider';

interface UseSeriesManagerProps {
  perpsList: PerpTokenData[];
  fetchPerpsList: () => void;
}

export enum WindowTenorEnum {
  D1 = '1D',
  D3 = '3D',
  W1 = '1W',
  W2 = '2W',
  M1 = '1M',
  M2 = '2M',
  M3 = '3M',
  M6 = '6M',
  M9 = '9M',
  Y1 = '1Y',
}

export interface OptionConfig<T> {
  key: string;
  value: T;
  setValue: (value: T) => void;
  label: string;
  options: { label: string; value: T }[];
  otherOptions?: { label: string; value: T }[];
}

export const useSeriesManager = (props: UseSeriesManagerProps) => {
  const { perpsList, fetchPerpsList } = props;

  const [type, setType] = useState<RequestTypeEnum>(RequestTypeEnum.VOLS);
  const [loading, setLoading] = useState(false);

  const typeOptions = [
    { value: RequestTypeEnum.VOLS, label: 'Volatility' },
    { value: RequestTypeEnum.PERPETUAL, label: 'Perpetual' },
  ];

  const perpetualOptions = usePerpetualOptions({ perpsList });
  const volatilityOptions = useVolatilityOptions();

  const getOptionsArray = (): OptionConfig<any>[] => {
    if (type === RequestTypeEnum.PERPETUAL) {
      return perpetualOptions.options;
    }
    return volatilityOptions.options;
  };

  useEffect(() => {
    if (perpsList && perpsList.length > 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    Promise.resolve(fetchPerpsList()).finally(() => {
      setLoading(false);
    });
  }, [fetchPerpsList, perpsList]);

  return {
    type,
    setType,
    typeOptions,
    options: getOptionsArray(),
    loading,
  };
};
